import React from "react";
import { GroupOutlined as Group, PersonOutline as Person } from "@mui/icons-material";
import { ICellRendererParams } from "ag-grid-community";

import { CellWrapper } from "fond/projects/ProjectList/entityCellRenderer.styles";
import { ExtendedPermission } from "fond/types";

const IdentityTypeCellRenderer: React.FC<ICellRendererParams<ExtendedPermission, ExtendedPermission["IdentityType"]>> = ({ value }) => {
  if (!value) return null;

  return (
    <CellWrapper>
      {value === "user" && <Person color="action" data-testid="share-permission-icon-user" />}
      {value === "account" && <Group color="action" data-testid="share-permission-icon-account" />}
    </CellWrapper>
  );
};

export default IdentityTypeCellRenderer;
